import { useTranslation } from 'react-i18next';
import { IconBrandWhatsapp } from '@tabler/icons-react';

import { motion } from 'framer-motion';

import { Typography } from '@components/typography';
import { MovingBorderContainer } from '@components/ui/moving-border';

import { isMobileDevice } from '@globalUtils/environment';

import { cn } from '@src/lib/utils';

/*
import { useTranslation } from 'react-i18next';

import { SpotlightButton } from '@components/ui/spotlight-button';

import { cn } from '@src/lib/utils';

export function CTA({ className = '' }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <div className={cn('relative', className)}>
      <SpotlightButton>
        <div className="text-white relative z-30 font-semibold">{t('Book a call')}</div>
      </SpotlightButton>
    </div>
  );
}
*/

export function CTA({
  className = '',
  fullWidth = true,
  'data-id': dataId,
}: {
  className?: string;
  fullWidth?: boolean;
  'data-id'?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className={cn('relative', className)}>
      <a
        href="https://w.app/rzv1fu"
        target="_blank"
        rel="noreferrer"
        data-id={dataId}
        className="no-underline"
      >
        <div className="w-[200px] flex items-center justify-center gap-2 font-bold cursor-pointer py-2 bg-black border-1 border-black rounded-xl text-white shadow-lg">
          <IconBrandWhatsapp size={20} />
          {t('Book a call')}
        </div>
      </a>
    </div>
  );
}

export function CTASignIn({ className = '' }: { className?: string }) {
  return null;
  /*
  const { t } = useTranslation();

  if (isMobileDevice())
    return (
      <a
        href="https://console.usecloser.ai/"
        className="w-fit mb-0! bg-white no-underline group mb-8 cursor-pointer relative  shadow-2xl shadow-zinc-200 rounded-full p-px text-xs font-semibold leading-6 text-white inline-block"
      >
        <Typography variant="caption" className="font-bold">
          {t('Log in')}
        </Typography>
      </a>
    );

  return (
    <div className={cn('relative w-[130px]', className)}>
      <MovingBorderContainer fullWidth>
        <a
          href="https://console.usecloser.ai/"
          className="w-full mb-0! bg-white no-underline group mb-8 cursor-pointer relative  shadow-2xl shadow-zinc-200 rounded-full p-px text-xs font-semibold leading-6 text-white inline-block"
        >
          <span className="absolute inset-0 overflow-hidden rounded-full">
            <span className="absolute inset-0 rounded-full bg-[image:radial-gradient(75%_100%_at_50%_0%,rgba(56,189,248,0.6)_0%,rgba(56,189,248,0)_75%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
          </span>
          <div className="w-full text-white! relative flex space-x-2 items-center z-10 rounded-full bg-white py-0.5 px-4 ring-1 ring-black/10 flex justify-between">
            <span className="text-black">{t('Sign in')}</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <motion.path
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M10.75 8.75L14.25 12L10.75 15.25"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 1 }}
              ></motion.path>
            </svg>
          </div>
          <span className="absolute -bottom-0 left-[1.125rem] h-px w-[calc(100%-2.25rem)] bg-gradient-to-r from-emerald-400/0 via-emerald-400/90 to-emerald-400/0 transition-opacity duration-500 group-hover:opacity-40"></span>
        </a>
      </MovingBorderContainer>
    </div>
  );
  */
}
